import { KbGuidePage } from "@/components/kb/KbGuidePage";

export function Guide009TemplateNextSessionPrep() {
  return <KbGuidePage slug="guide-009-template-next-session-prep" />;
}

(Guide009TemplateNextSessionPrep as unknown as { path: string }).path = "/automations/template-next-session-prep";
